module.exports = __webpack_public_path__ + "website/img/drainage.f8440e54.png";